module.exports = __webpack_public_path__ + "img/next.d5d60ee0.svg";